import { render, staticRenderFns } from "./modifyWaybillNumberModal.vue?vue&type=template&id=01abaf60&scoped=true"
import script from "./modifyWaybillNumberModal.vue?vue&type=script&lang=js"
export * from "./modifyWaybillNumberModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01abaf60",
  null
  
)

export default component.exports